import { useTranslation } from 'react-i18next';
import { linkedOrganizationPath } from '~/utils/linkedOrganizationPath';

/** `linkedOrganizationId` is the seller's organization when the buyer answers for them. */
export function NoShipFromFacilityNotice({
  linkedOrganizationId,
}: Readonly<{ linkedOrganizationId?: string }>) {
  const { t } = useTranslation('rfq-view');
  return (
    <p className="text-sm text-error-600" role="alert">
      {linkedOrganizationId === undefined ? (
        t('rfq_view.no_ship_from_facility_error')
      ) : (
        <>
          {t('rfq_view.no_facility')}{' '}
          <a
            className="underline"
            href={linkedOrganizationPath(linkedOrganizationId)}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('rfq_view.view_seller_contacts')}
          </a>
        </>
      )}
    </p>
  );
}
